import { CDN_URL } from "@workspace/casino_config/cdn";

const getCdnResource = (src = "") => `${CDN_URL}/${src}`;

export default getCdnResource;
